import React, { useMemo } from 'react';
import { WorldSection } from './WorldPageHeader';
import { StatusBadge } from './VerificationBits';
import { QuestDataCheck } from './QuestDataCheck';
import { checkProgressionNames } from '../../utils/progressionLookup';
import type { WorldData } from '../../types/world';

/** Panel técnico: nombres usados en evoluciones y recetas frente a los datos cargados. */
export function ProgressionDataCheck({
  w
}: {
  w: WorldData;
}) {
  const checks = useMemo(() => checkProgressionNames(w), [w]);
  const missing = checks.filter(c => !c.found);
  return <>
    <QuestDataCheck w={w} data-id="element-2264" data-mp="3a9p06kik969u" />
    <WorldSection id="progresion" title="Guías de progresión: nombres frente a los datos" data-id="element-2265" data-mp="35g2sz7v61ulf">
      <p className="mb-4 text-sm text-gray-400" data-id="element-2266" data-mp="30hro7bjqaaa2">
        {checks.length - missing.length} de {checks.length} ítems, monstruos, mapas y NPC usados en Evoluciones y Alas se identificaron en los archivos cargados (por ID, nombre, alias o variante).
        “Identificado” solo confirma que existe en el catálogo, no que esté disponible ni sus requisitos. “No encontrado” significa que se revisaron ID, nombre, nombres alternativos y variantes.
        Las rutas de misión (kind = quest) se cuentan con sus pares monstruo/mapa de route_targets.csv. Etapas, cantidades, costes, recetas de la Chaos Machine y coordenadas de NPC sin apariciones no figuran en ningún archivo.
      </p>
      <div className="overflow-x-auto rounded-2xl border border-white/10" data-id="element-2267" data-mp="2dgvhr27m3gzi">
        <table className="w-full min-w-[620px] text-left text-sm" data-id="element-2268" data-mp="1zi5iph18f78i">
          <thead className="bg-white/[0.03] text-xs text-gray-400" data-id="element-2269" data-mp="24jl1t3jun3o9">
            <tr data-id="element-2270" data-mp="1qj1z8by5kpth">
              <th className="px-4 py-3 font-semibold" data-id="element-2271" data-mp="1qjk39ur248by">Tipo</th>
              <th className="px-4 py-3 font-semibold" data-id="element-2272" data-mp="1ql4y7lha9tac">Nombre en la guía</th>
              <th className="px-4 py-3 font-semibold" data-id="element-2273" data-mp="1ukngsalmtsa0">Dónde se usa</th>
              <th className="px-4 py-3 font-semibold" data-id="element-2274" data-mp="3kxusw5fh76is">En los datos</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-white/5" data-id="element-2275" data-mp="3ox3lh6ys4ycr">
            {[...missing, ...checks.filter(c => c.found)].map(c => <tr key={`${c.kind}|${c.name}`} data-id="element-2276" data-mp="11nuqe77ci3kz">
                <td className="px-4 py-3 text-gray-400" data-id="element-2277" data-mp="wql593qzoe2y">{c.kind}</td>
                <td className="px-4 py-3 text-gray-200" data-id="element-2278" data-mp="sp9c4o8wpaq0">{c.name}</td>
                <td className="px-4 py-3 text-gray-400" data-id="element-2279" data-mp="spj4gihfbtyv">{c.where}</td>
                <td className="px-4 py-3" data-id="element-2280" data-mp="nr7v08v1jlh6">
                  {c.found ? <span className="font-mono text-[12px] text-white" data-id="element-2281" data-mp="nsiuhwhge72h">{c.found}</span> : <StatusBadge status="mismatch" label="No encontrado" data-id="element-2282" data-mp="1kfx8zo3jrtxv" />}
                  {c.detail && <span className="mt-0.5 block text-xs text-gray-500" data-id="element-2283" data-mp="1gg4z982f3hqx">{c.detail}</span>}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </WorldSection>
    </>;
}